import { render, staticRenderFns } from "./TheCartForm.vue?vue&type=template&id=bbe2b6c2&scoped=true&"
import script from "./TheCartForm.vue?vue&type=script&lang=ts&"
export * from "./TheCartForm.vue?vue&type=script&lang=ts&"
import style0 from "./TheCartForm.vue?vue&type=style&index=0&id=bbe2b6c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe2b6c2",
  null
  
)

export default component.exports